module.exports = __webpack_public_path__ + "src/components/FixedNav/iconplatform.png?3c504ca8";


//////////////////
// WEBPACK FOOTER
// ./src/components/FixedNav/iconplatform.png
// module id = 2792
// module chunks = 1